export const maskEmail = (email) => {
	if (!email) {
		return null
	}
	const [local, domain] = email.split('@')
	if (local.length > 1) {
		const maskedLocal = local.slice(0, 1) + '*'.repeat(local.length - 2) + local.slice(-1)
		return `${maskedLocal}@${domain}`
	} else {
		return email
	}
}

export const maskTelephone = (obj) => {
	if (!obj) {
		return null
	}
	const cleanedObj = obj.replace(/[\s.]/g, '').trim()
	return '** ** ** ** ' + cleanedObj.slice(-2)
}

export const maskObj = (obj) => {
	if (!obj) {
		return null
	}
	return obj.replace(/\S/g, 'X')
}

export const maskNSS = (nss) => {
	if (!nss) {
		return null
	}
	const cleanNSS = nss.replace(/\s+/g, '')
	return cleanNSS.slice(0, 1) + '*'.repeat(cleanNSS.length - 6) + cleanNSS.slice(-5)
}

export const maskNumeroAssure = (obj) => {
	if (!obj) {
		return null
	}
	return '******'
}

export const isAfterNow = (dateString) => {
	const date = new Date(dateString)
	const now = new Date()
	date.setHours(0, 0, 0, 0)
	now.setHours(0, 0, 0, 0)
	return date > now
}
